import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function EnterIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="12.125" height="13.288" viewBox="0 0 12.125 13.288" {...props}>
      <g id="Group_5999" data-name="Group 5999" transform="translate(-799.619 -909.107)">
        <g id="Group_5817" data-name="Group 5817" transform="translate(809.621 917.425) rotate(180)">
          <line id="Line_457" data-name="Line 457" x2="7.037" transform="translate(-1.373 1.675)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
          <path id="Path_6435" data-name="Path 6435" d="M816.356,915.015l1.971,1.971-1.971,1.966" transform="translate(-812.01 -915.309)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
        </g>
        <g id="Group_5818" data-name="Group 5818" transform="translate(800.494 909.982)">
          <path id="Path_6436" data-name="Path 6436" d="M807.585,912.207c-.014-.425-.029-.433-.051-.858-.031-.6-.312-1.132-.618-1.175a21.191,21.191,0,0,0-5.695,0c-.306.043-.587.574-.618,1.175q-.219,4.4,0,8.8c.031.6.312,1.132.618,1.175a21.191,21.191,0,0,0,5.695,0c.307-.043.588-.573.618-1.175.02-.407.037-.5.051-.9"
            transform="translate(-800.494 -909.982)"
            fill="none" stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default EnterIcon;



// WEBPACK FOOTER //
// ./src/components/icons/EnterIcon.jsx